import { initializeApp, getApps } from 'firebase/app';
import { getAuth, setPersistence, inMemoryPersistence, createUserWithEmailAndPassword,
  signInWithEmailAndPassword, updateProfile, signOut, applyActionCode, verifyPasswordResetCode, confirmPasswordReset } from 'firebase/auth';
import { setPlayerCsrf } from './shared/playerTransport';

let csrf = '', identity;
export const accountRequest = async (path, data) => {
  const response = await fetch(`/api${path}`, { method: data === undefined ? 'GET' : 'POST', credentials: 'same-origin',
    headers: data === undefined ? {} : { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf },
    ...(data === undefined ? {} : { body: JSON.stringify(data) }) });
  const value = await response.json();
  if (!response.ok) throw Object.assign(new Error(value.error?.message || 'The request could not be completed.'), { status: response.status, code: value.error?.code });
  return value;
};
export const initializeAccount = async () => {
  const config = await accountRequest('/bootstrap');
  csrf = config.csrfToken; setPlayerCsrf(csrf);
  identity = getAuth(getApps().length ? getApps()[0] : initializeApp(config.identity));
  await setPersistence(identity, inMemoryPersistence);
};
export const loginAccount = async ({ email, password, fullName, signup }) => {
  try {
    const credential = await (signup ? createUserWithEmailAndPassword : signInWithEmailAndPassword)(identity, email.trim(), password);
    if (signup) await updateProfile(credential.user, { displayName: fullName.trim() });
    const result = await accountRequest('/auth/session', { idToken: await credential.user.getIdToken(true),
      fullName: signup ? fullName.trim() : credential.user.displayName || undefined });
    return result;
  } finally { if (identity?.currentUser) await signOut(identity); }
};
export const completeEmailAction = async code => { await applyActionCode(identity, code); };
export const validatePasswordReset = code => verifyPasswordResetCode(identity, code);
export const completePasswordReset = (code, password) => confirmPasswordReset(identity, code, password);
export const logoutAccount = async () => { await accountRequest('/auth/logout', {}); if (identity?.currentUser) await signOut(identity); };
